app.controller('MenuLeftController', ['$rootScope', '$scope', '$state', function ($rootScope, $scope, $state) {

    const menuModel = $rootScope.model.menu;

    $scope.onPrimaryPathClicked = function (path) {
        if (path !== menuModel.last_path_selection) {
            menuModel.last_path_selection = path;
        } else {
            menuModel.last_path_selection = null;
        }
    }


    $scope.isSelectedPath = function (path, notPath) {
        const pathname = menuModel.last_path_selection;
        if (notPath) {
            notPath = Array.isArray(notPath) ? notPath : [notPath];

            for (let i = 0; i < notPath.length; i++) {
                if ($rootScope.site_helper.doesMatchPath(notPath[i], pathname)) {
                    return false;
                }
            }
        }
        return $rootScope.site_helper.doesMatchPath(path, pathname)
    }

    $scope.isActivePath = function (path, notPath) {
        const pathname = window.location.pathname;
        if (notPath) {
            notPath = Array.isArray(notPath) ? notPath : [notPath];

            for (let i = 0; i < notPath.length; i++) {
                if ($rootScope.site_helper.doesMatchPath(notPath[i], pathname)) {
                    return false;
                }
            }
        }
        if (Array.isArray(path)) {
            for (let i = 0; i < path.length; i++) {
                if ($rootScope.site_helper.doesMatchPath(path[i], pathname)) {
                    return true;
                }
            }
            return false;
        }
        return $rootScope.site_helper.doesMatchPath(path, pathname)

    }

}]);